/** The job with its current status stamped, unless the last stamp already says it. */
export function stamped(r, at) {
    const history = r.history ?? [];
    if (history.at(-1)?.status === r.engagement.status)
        return r;
    return { ...r, history: [...history, { status: r.engagement.status, at }] };
}
/** The job with one more note, stamped with its time. */
export const withNote = (r, note, at, mine = false) => ({
    ...r,
    notes: [...(r.notes ?? []), { ...note, at, ...(mine ? { mine } : {}) }],
});
/** When the job first reached `status`, if this phone saw it. */
export const reachedAt = (r, status) => r.history?.find((s) => s.status === status)?.at;
//# sourceMappingURL=history.js.map